<template>
  <div class="wc-layout wc-layout--mobile-account-subpage">
    <WCMobileHeaderV2 class="mobile-header" />
    <div :class="mobileHeaderStyles" role="main">
      <WCMobileSubpageHeader :title="$route.meta.title ? $route.meta.title : $route.name" />
      <div class="wc-layout__body container-fluid">
        <div class="">
          <router-view />
        </div>
      </div>
    </div>
    <WCEmployeeAssociationBanner v-if="isEmployee && isCustomer" />
    <WCBottomNavigation v-else-if="!isEmployee" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WCMobileSubpageHeader from '@/components/WCMobileSubpageHeader/WCMobileSubpageHeader.vue';
import WCMobileHeaderV2 from '@/components/WCMobileHeaderV2/WCMobileHeaderV2.vue';
import WCBottomNavigation from '@/components/WCBottomNavigation/WCBottomNavigation.vue';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';
import WCEmployeeAssociationBanner from '@/modules/employee/components/WCEmployeeAssociationBanner/WCEmployeeAssociationBanner.vue';
import MobileHeaderHeightMixin from '@/mixins/MobileHeaderHeightMixin';

export default {
  name: 'MobileAccountSubpage',
  components: {
    WCMobileSubpageHeader,
    WCMobileHeaderV2,
    WCBottomNavigation,
    WCEmployeeAssociationBanner,
  },
  mixins: [EmployeeMixin, MobileHeaderHeightMixin],
  computed: {
    ...mapGetters({
      isScanAndGoMode: 'user/isCustomerModeScan',
    }),
    /**
     * Property to check if multistore
     */
    isMultiStore() {
      return this.$configuration.multistore;
    },
    mobileHeaderStyles() {
      return {
        'account-page__body': this.isMultiStore,
        'wc-single-store-layout__body': !this.isMultiStore,
        'account-page__body-scan-mode': this.isScanAndGoMode,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.account-page__body {
  padding-top: var(--mobile-header-height);
  padding-bottom: $mobile-body-padding-bottom;
}

.account-page__body-scan-mode {
  padding-top: var(--mobile-header-height);
}

.wc-single-store-layout__body {
  padding-top: var(--mobile-header-height);
  padding-bottom: $mobile-body-padding-bottom;
}

.wc-layout--mobile-account-subpage {
  .wc-layout__body {
    padding-bottom: $pad-3 * 3.7;
    padding-top: 2rem;
  }
}
</style>
